import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';

import { KimLhcService } from '@/infra/services/kim-lhc';
import { QUERY_KEYS } from '@/utils/query-keys';

interface UpdateKimLhcParams {
	id: string;
	file_id: string;
	company_id: string;
	organization_id: string;
	workstation_id?: string;
	line_id?: string;
	sector_id?: string;
	activity_id?: string;
	evaluator_id?: string;
	day_duration?: number;
	activity_duration?: number;
	collect_date?: string;
	movement_frequency?: number;
	load_weight?: number;
	load_weight_men?: number;
	load_weight_women?: number;
	load_transport_in_pairs?: boolean;
	load_inclination?: boolean;
	effective_weight?: number;
	load_handling_conditions?: number;
	body_posture?: string;
	posture_additional_factor_twist?: string;
	posture_additional_factor_load_center?: string;
	posture_additional_factor_arms?: string;
	posture_additional_factor_hands?: string;
	work_condition_hands_position?: string;
	work_condition_transfer?: string;
	work_condition_spatial_condition?: string;
	work_condition_adverse?: string;
	work_condition_clothes?: string;
	work_condition_hold_load?: string;
	step?: number;
}

const Service = KimLhcService.getInstance();

export const useUpdateKimLhcReport = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: UpdateKimLhcParams) => await Service.update(params),
		onSuccess: () => {
			message.success(I18n.get('Report updated successfully'));
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_KIM_LHC] });
		},
		onError: () => {
			message.error(I18n.get('Error updating report'));
		}
	});
};
